import { render, staticRenderFns } from "./best-seller.vue?vue&type=template&id=178e2ff0"
import script from "./best-seller.vue?vue&type=script&lang=js"
export * from "./best-seller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports